module.exports = __webpack_public_path__ + "media/images/swiss/offers/digital-voucher-app-29abae0e1b27674950a058db3822eb56.jpg";